import React, { useState } from "react";
import axios from "axios";

/** JWT 기반 회원 로그인 공통 컴포넌트. 관리자용 LoginForm 과 동일 패턴, 필드명만 회원 기준. */
export default function LoginForm({ apiBaseUrl = "", onLoginSuccess, onGoJoin }) {
  const [memberAccount, setMemberAccount] = useState("");
  const [memberPassword, setMemberPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      // 계정은 가입 폼과 동일하게 트림해 보낸다(비밀번호는 절대 트림하지 않는다).
      const res = await axios.post(`${apiBaseUrl}/login`, { memberAccount: memberAccount.trim(), memberPassword });
      if (res.data.success) {
        onLoginSuccess(res.data.data);
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.message || "로그인 중 오류가 발생했습니다.");
    }
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <h2>로그인</h2>
      <input
        type="text"
        placeholder="아이디"
        value={memberAccount}
        onChange={(e) => setMemberAccount(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder="비밀번호"
        value={memberPassword}
        onChange={(e) => setMemberPassword(e.target.value)}
        required
      />
      {error && <p className="error">{error}</p>}
      <button type="submit">로그인</button>
      {onGoJoin && (
        <p className="auth-switch">
          아직 계정이 없으신가요? <button type="button" className="link-btn" onClick={onGoJoin}>회원가입</button>
        </p>
      )}
    </form>
  );
}
